export default __webpack_public_path__ + "f50940f164fe4def438dcc8267fe1c6f.png";